
const lessonHistory = (state = [{current_scene: 1, previous_scene: null}], action) => {
    if (action.type === 'ADD_TO_HISTORY')
    {
        let history = state; 
        history.push(action.payload);
        return history;
    } else {
        return state;
    } 
}
export default lessonHistory;